import {
  CompleteUploadAction,
  CompleteUploadFileAction,
  CompleteUploadFilePayload,
  GetUploadUrlAction,
  GetUploadUrlPayload,
  ResetUploadAction,
  StartUploadAction,
  StartUploadPayload,
  UpdateBlobUrlAction,
  UpdateBlobUrlPayload,
  UpdateFilesAction,
  UpdateFilesPayload,
  UpdateUploadingStatsAction,
  UpdateUploadingStatsPayload,
  UpdateUploadStatusAction,
  UpdateUploadStatusPayload,
  UploadFailAction,
  UploadFailPayload,
  UploadFileAction,
  UploadSuccessAction,
} from 'types/actions/upload';

import { uploadConstant } from '../actionTypes';

export const getUploadUrl = (payload: GetUploadUrlPayload): GetUploadUrlAction => ({
  type: uploadConstant.GET_UPLOAD_URL,
  payload,
});

export const updateBlobUrl = (payload: UpdateBlobUrlPayload): UpdateBlobUrlAction => ({
  type: uploadConstant.UPDATE_UPLOAD_URL,
  payload,
});

export const updateUploadStatus = (
  payload: UpdateUploadStatusPayload
): UpdateUploadStatusAction => ({
  type: uploadConstant.UPDATE_UPLOAD_STATUS,
  payload,
});

export const updateFiles = (payload: UpdateFilesPayload): UpdateFilesAction => ({
  type: uploadConstant.UPDATE_FILES,
  payload,
});

export const updateUploadingStats = (
  payload: UpdateUploadingStatsPayload
): UpdateUploadingStatsAction => ({
  type: uploadConstant.UPDATE_UPLOADING_STATS,
  payload,
});

export const uploadSuccess = (): UploadSuccessAction => ({
  type: uploadConstant.UPLOAD_SUCCESS,
});

export const uploadFail = (payload: UploadFailPayload): UploadFailAction => ({
  type: uploadConstant.UPLOAD_FAIL,
  payload,
});

export const startUpload = (payload: StartUploadPayload): StartUploadAction => ({
  type: uploadConstant.START_UPLOAD,
  payload,
});

export const resetUpload = (): ResetUploadAction => ({
  type: uploadConstant.RESET_UPLOAD,
});

export const uploadFile = (): UploadFileAction => ({
  type: uploadConstant.UPLOAD_FILE,
});

export const completeUpload = (): CompleteUploadAction => ({
  type: uploadConstant.COMPLETE_UPLOAD,
});

export const completeUploadFile = (
  payload: CompleteUploadFilePayload
): CompleteUploadFileAction => ({
  type: uploadConstant.COMPLETE_UPLOAD_FILE,
  payload,
});
